import { render, staticRenderFns } from "./AppArrow.vue?vue&type=template&id=a8adfb2e&"
import script from "./AppArrow.vue?vue&type=script&lang=js&"
export * from "./AppArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports